import { render, staticRenderFns } from "./salesanalysis_report.vue?vue&type=template&id=66ffdc72&"
import script from "./salesanalysis_report.vue?vue&type=script&lang=js&"
export * from "./salesanalysis_report.vue?vue&type=script&lang=js&"
import style0 from "./salesanalysis_report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports